import React from 'react';
import Section from '../Section';
import TitledContent from '../TitledContent';

const ClientIdentification = ({ clientType }) => (
  <Section displayGrid title="Identificação do cliente">
    <TitledContent fullWidth title="Tipo de pessoa" content={clientType} />
  </Section>
);

export default ClientIdentification;
